import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

@Injectable({
  providedIn: 'root',
})
export class FontAwesomeService {
  constructor(private readonly library: FaIconLibrary) {}

  checkIconAvailable(prefix: string, name: string): boolean {
    return (
      this.library.getIconDefinition(prefix as IconPrefix, name as IconName) !==
      null
    );
  }

  async loadIconPack(prefix: IconPrefix): Promise<void> {
    switch (prefix) {
      case 'fal': {
        const { fal } = await import('@fortawesome/pro-light-svg-icons');
        this.library.addIconPacks(fal);
        break;
      }
      case 'fas': {
        const { fas } = await import('@fortawesome/pro-solid-svg-icons');
        this.library.addIconPacks(fas);
        break;
      }
      case 'far': {
        const { far } = await import('@fortawesome/pro-regular-svg-icons');
        this.library.addIconPacks(far);
        break;
      }
      case 'fab': {
        const { fab } = await import('@fortawesome/free-brands-svg-icons');
        this.library.addIconPacks(fab);
        break;
      }
    }
  }
}
